import { createConfirmation } from 'react-confirm';
import ConfirmModal from './ConfirmModal';

const confirmFn = createConfirmation(ConfirmModal);
export const confirm = label => confirmFn({ label });
